var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shop__header"},[_c('h1',{staticClass:"shop__heading mb-4"},[_vm._v(_vm._s(_vm.heading))]),_vm._v(" "),_c('p',{staticClass:"shop__paragraph"},[_vm._v(_vm._s(_vm.subheading))])])}
var staticRenderFns = []

export { render, staticRenderFns }